<template>
  <div class="text-tooltip" :class="{'asSpan': type === 'span', 'asP': type === 'p'}">
    <el-tooltip class="item" effect="dark" :disabled="isShowTooltip" :content="content" placement="top">
      <span class="over-flow" :class="className" @mouseover="onMouseOver(refName)">
        <span :ref="refName" :class="{'geekBlue': clrs === 'blue'}">{{ content || '-' }}</span>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TextTooltip',
  props: {
    clrs: {
      type: String,
      default: () => {
        return '';
      }
    },
    // 显示的文字内容
    content: {
      type: String,
      default: () => {
        return '';
      }
    },
    // 外层框的样式，在传入的这个类名中设置文字显示的宽度
    className: {
      type: String,
      default: () => {
        return '';
      }
    },
    // 为页面文字标识（如在同一页面中调用多次组件，此参数不可重复）
    refName: {
      type: String,
      default: () => {
        return '';
      }
    },
    type: {
      type: String,
      default: () => {
        return 'span';
      }
    }
  },
  data() {
    return {
      isShowTooltip: true
    };
  },
  methods: {
    onMouseOver(str) {
      if (str && this.$refs[str]) {
        const parentWidth = this.$refs[str].parentNode.parentNode.offsetWidth;
        const contentWidth = this.$refs[str].offsetWidth;
        // 判断是否开启tooltip功能
        if (contentWidth > parentWidth) {
          this.isShowTooltip = false;
        } else {
          this.isShowTooltip = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.over-flow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.wid190 {
    width: inherit;
}
.asSpan{
  display: inline-block;
  vertical-align: top;
}

.geekBlue{
  color:#597EF7;
}
</style>
